<template>
  <NuxtLink :to="localePath('/')" class="flex items-center">
    <Logo class="h-full" />
  </NuxtLink>
</template>
<script lang="ts" setup>
import Logo from '~/assets/logo/ircam.svg'
const localePath = useLocalePath()
</script>
